import "./ribuyitem.styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
const RIBuyItem = ({
  tempObject,
  handleDelete,
  handleMoveToStock,
  unitsContext,
}) => {
  return (
    <div className="ri-tobuy-item">
      <div className="ri-tobuy-item-details">
        <span className="ri-tobuy-item-name">{tempObject["itemName"]}</span>
        <span className="ri-tobuy-date">{tempObject["dateValue"]}</span>
        <span className="ri-tobuy-item-quantity">
          {tempObject["quantity"]} {unitsContext[tempObject["unit"]]}
        </span>
      </div>
      <div className="ri-tobuy-item-buttons">
        <span
          className="ri-tobuy-item-delete"
          onClick={() => handleDelete(tempObject["_id"])}
        >
          <FontAwesomeIcon icon={faTrash} />
        </span>
        <span
          className="ri-tobuy-item-move"
          onClick={() => handleMoveToStock(tempObject["_id"])}
        >
          Move to stock
        </span>
      </div>
    </div>
  );
};
export default RIBuyItem;
